import { useEffect, useState } from 'react';

const BREAKPOINTS = {
  mobileSmall: 400,
  mobile: 576,
  tablet: 768,
  desktop: 992,
  largeDesktop: 1200
};

const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    mobileSmall: window?.innerWidth < BREAKPOINTS.mobileSmall,
    mobile: window?.innerWidth < BREAKPOINTS.mobile,
    tablet: window?.innerWidth < BREAKPOINTS.tablet,
    desktop: window?.innerWidth < BREAKPOINTS.desktop,
    largeDesktop: window?.innerWidth < BREAKPOINTS.largeDesktop
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        mobileSmall: window?.innerWidth < BREAKPOINTS.mobileSmall,
        mobile: window?.innerWidth < BREAKPOINTS.mobile,
        tablet: window?.innerWidth < BREAKPOINTS.tablet,
        desktop: window?.innerWidth < BREAKPOINTS.desktop,
        largeDesktop: window?.innerWidth < BREAKPOINTS.largeDesktop
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export default useResponsive;
